export const tagTypeKeys = {
    Student: "student",
    Question: "question",
    Assessment: "assessment"
};